import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import IconButtonNonReact from '../components/IconButtonNonReact';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import HouseTypesViewerEntryStatuses from './HouseTypesViewerEntryStatuses';
import HouseTypesViewerEntryPriceRange from './HouseTypesViewerEntryPriceRange';
import Checkbox from '../components/Checkbox';
import Star from '../components/Star';
export default class HouseTypesViewerEntry {
	constructor({houseTypes, callbackClicked, houseTypeViewModel, showImagesFullScreen,
		showStreetView, enterHouse, hide, callbackAddFavourite, callbackRemoveFavourite,
		configuration}){
		this._callbackHide =hide;
		this._callbackClicked = callbackClicked;
		this._callbackAddFavourite = callbackAddFavourite;
		this._callbackRemoveFavourite = callbackRemoveFavourite;
		this._showImagesFullScreen= showImagesFullScreen;
		this._showStreetView = showStreetView;
		this._enterHouse= enterHouse;
		this._houseTypes = houseTypes;
		this._houseTypeViewModel = houseTypeViewModel;
		this._handleClickedEntry= this._handleClickedEntry.bind(this);
		this._handleClicked= this._handleClicked.bind(this);
		this._statuses = new HouseTypesViewerEntryStatuses({houseTypes});
		this._priceRange = new HouseTypesViewerEntryPriceRange({houseTypes});
		this._handleStarSelectedChanged = this._handleStarSelectedChanged.bind(this);
		this._handleCheckboxChanged = this._handleCheckboxChanged.bind(this);
		this._houseTypeViewModelSelectedChanged = this._houseTypeViewModelSelectedChanged.bind(this);
		this._handleClickButtonWalkmode = this._handleClickButtonWalkmode.bind(this);
		this._showFloorPlans = this._showFloorPlans.bind(this);
		this._handleClickImage = this._handleClickImage.bind(this);
		this._showRoomImages = this._showRoomImages.bind(this);
		this._handleShowConfigurator = this._handleShowConfigurator.bind(this);
		this._expandAbout = this._expandAbout.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('house-types-viewer-entry');
		this._imageWrapperElement = document.createElement('div');
		this._imageWrapperElement.classList.add("image-wrapper");
		this._img = document.createElement('img');
		this._img.classList.add('image');
		const firstHouseTypeWithName = houseTypes[0];
		const firstPlot = firstHouseTypeWithName.plots[0];
		this._firstPlot = firstPlot;
		const firstUnit = firstPlot.unit;
		this._img.src = `${Urls.getAssetsForSite(configuration.siteSlug)}${UrlHelper.removeStartSlash(firstUnit.frontViewImage.getBestEntryToFitHeight(50).relativePath)}`;
		this._infoWrapperElement = document.createElement('div');
		this._infoWrapperElement.classList.add('info-wrapper');
		
			this._descriptionElement = document.createElement('div');
			this._descriptionElement.classList.add('description');
			this._descriptionTextElement = document.createElement('div');
			this._descriptionTextElement.classList.add('description-text');
			this._descriptionTextElement.innerHTML = `${firstHouseTypeWithName.name}`;
			this._descriptionElement.appendChild(this._descriptionTextElement);
			this._infoWrapperElement.appendChild(this._descriptionElement);
		
		this._topElement = document.createElement('div');
		this._topElement.classList.add('top');
		this._topElement.appendChild(this._imageWrapperElement);
		this._imageWrapperElement.appendChild(this._img);
		this._imageWrapperElement.addEventListener('click', this._handleClickImage);
		this._topElement.appendChild(this._infoWrapperElement);
		this._element.appendChild(this._topElement);
		this._element.addEventListener('click', this._handleClicked);
		this._handleStarSelectedChanged = this._handleStarSelectedChanged.bind(this);
		this._plotPriceRangeElement = document.createElement('div');
		this._plotPriceRangeElement.classList.add('price-range');
		this._nBedroomsElement = document.createElement('div');
		this._nBedroomsElement.classList.add('n-bedrooms');
		const nBathroomString = configuration.showNBathrooms?` and ${firstPlot.nBathrooms} Bathrooms`:'';
		this._nBedroomsElement.innerHTML = ' - '+String(firstPlot.nBedrooms)+' Bedrooms'+nBathroomString;
		
		this._smallButtonsAndPriceElement = document.createElement('div');
		this._smallButtonsAndPriceElement.classList.add('small-buttons-and-price-range');
		[this._plotPriceRangeElement, this._nBedroomsElement]
			.forEach(childElement=>this._descriptionElement.appendChild(childElement));
		[this._statuses.element, this._smallButtonsAndPriceElement]
			.forEach(childElement=>this._infoWrapperElement.appendChild(childElement));
		/*const starFactory = React.createFactory(Star);
		
		this._starElement = document.createElement('div');
		ReactDOM.render(starFactory(
			{ 
				onSelectedChange:this._handleStarSelectedChanged, 
				ref:this._star,
				stopEventPropagation:true
			}),
			this._starElement);
		this._smallButtonsElement.appendChild(this._starElement);
		*/
		this._smallButtonsElement= document.createElement('div');
		this._smallButtonsElement.classList.add('small-buttons');
		const hasOneOrMoreRoomImages=firstPlot.hasOneOrMoreRoomImages;
		if(configuration.outside360Enabled){
			this._iconButtonWalkmode = new IconButtonNonReact({ 	
					className:["button-show-street-view", "button-show"], 
					imgUrl:Urls.assets+'icons/UI_Button_Walkmode.png',
					onClick:this._handleClickButtonWalkmode
				});
			this._smallButtonsElement.appendChild(this._iconButtonWalkmode.element);
		}			
		this._iconButtonShowGallery = new IconButtonNonReact({
				className:["button-show-gallery", "button-show"], 
				imgUrl:hasOneOrMoreRoomImages?(Urls.assets+'icons/UI_Button_Gallery.png'):(Urls.assets+'icons/UI_Button_Gallery_Disabled.png'),
				onClick:hasOneOrMoreRoomImages?this._showRoomImages:()=>{}
			});
		this._smallButtonsElement.appendChild(this._iconButtonShowGallery.element);
			
		
		this._iconButtonShowFloorplan = new IconButtonNonReact({
				className:["button-show-floor-plan", "button-show"], 
				imgUrl:Urls.assets+'icons/UI_Button_Floorplan.png',
				onClick:this._showFloorPlans
			});
		this._smallButtonsElement.appendChild(this._iconButtonShowFloorplan.element);
		
		
		const hasConfiguratorOrTour=Urls.getConfiguratorUrlForPlot(this._firstPlot, configuration)?true:false
		if(hasConfiguratorOrTour){
			this._iconButtonEnterHouse = new IconButtonNonReact({
					className:["button-show-floor-plan", "button-show"], 
					imgUrl:Urls.assets+'icons/UI_Button_Enter_House.png',
					onClick:this._handleShowConfigurator
				});
			this._smallButtonsElement.appendChild(this._iconButtonEnterHouse.element);
		}
		this._smallButtonsAndPriceElement.appendChild(this._smallButtonsElement);
		this._smallButtonsAndPriceElement.appendChild(this._priceRange.element);
		
		const checkboxFactory = React.createFactory(Checkbox);
		this._checkboxElement = document.createElement('div');
		this._checkboxElement.classList.add('star');
		this._checkbox = ReactDOM.render(checkboxFactory(
			{  	toggleOnClick:true, 
				onChange:this._handleCheckboxChanged,
				stopEventsPropagating:true,
				ref:React.createRef()
			}),
			this._checkboxElement
		);
		this._checkboxRef = this._checkbox._checkboxRef;
		this._descriptionElement.appendChild(this._checkboxElement);
		
			this._aboutElement = document.createElement('div');
			this._aboutElement.classList.add('about');
			this._aboutElement.innerHTML = firstPlot.about;
			this._aboutElement.addEventListener('click', this._expandAbout);
			setTimeout(()=>{
			this._infoWrapperElement.appendChild(this._aboutElement);
			}, 0);
		houseTypeViewModel.addEventListener('selectedchanged', this._houseTypeViewModelSelectedChanged);
		this._element.addEventListener('click', this._handleClickedEntry);
		
	}
	_expandAbout(){
		if(this._aboutExpanded){
			this._aboutExpanded = false;
			this._element.removeChild(this._aboutElement);
			this._infoWrapperElement.appendChild(this._aboutElement);
			this._aboutElement.classList.remove('expanded');
			return;
		}
		this._aboutExpanded = true;
		this._infoWrapperElement.removeChild(this._aboutElement);
		this._element.appendChild(this._aboutElement);
		this._aboutElement.classList.add('expanded');
	}
	_handleStarSelectedChanged(selected){
		this._houseTypes.forEach(houseType=>{
			houseType.plots.forEach(plot=>{
				if(selected)this._callbackAddFavourite(plot);
				else this._callbackRemoveFavourite(plot);
			});
		});
	}
	_handleClickImage(){
		this._showImagesFullScreen([this._firstPlot.frontViewImage]);
	}
	_handleClickButtonWalkmode(){
		this._showStreetView({nearPlot:this._firstPlot});
		this._callbackHide();
	}
	_houseTypeViewModelSelectedChanged(e){
		this._checkboxRef.current.checked = e.value;
		if(e.value)
			this._element.classList.add('selected');
		else
			this._element.classList.remove('selected');
	}
	_handleClickedEntry(){
		this._houseTypeViewModel.selected = !this._houseTypeViewModel.selected;
	}
	_handleCheckboxChanged(e){
		this._houseTypeViewModel.selected = e.checked;
	}
	_showFloorPlans(){
		this._showImagesFullScreen(this._firstPlot.floorPlanImages);
	}
	_showRoomImages(){
		this._showImagesFullScreen(this._firstPlot.rooms.allImages);
	}
	_handleShowConfigurator(){
		this._enterHouse(this._firstPlot);
		this._callbackHide();
	}
	get number(){
		return this._houseTypes[0].number;
	}
	set filteredOut(value){
		if(value)
			this._element.classList.add('filtered-out');
		else
			this._element.classList.remove('filtered-out');
	}
	get element(){
		return this._element;
	}
	_handleClicked(){
		this._callbackClicked(this);
	}
}
